import { Tabs as T } from "radix-ui";
import type { ReactNode } from "react";

export const TabsRoot = T.Root;
export const TabsContent = T.Content;

export function TabsList({ children, label }: { children: ReactNode; label: string }) {
  return (
    <T.List aria-label={label} className="flex gap-1 overflow-x-auto shadow-[inset_0_-1px_0_var(--border)] [scrollbar-width:none]">
      {children}
    </T.List>
  );
}

export function Tab({ value, children, count, tour }: { value: string; children: ReactNode; count?: number; tour?: string }) {
  return (
    <T.Trigger
      value={value}
      data-tour={tour}
      className="relative flex h-9 shrink-0 items-center gap-1.5 border-b-2 border-transparent px-2.5 text-sm font-medium whitespace-nowrap text-fg-muted transition-colors transition-fast hover:text-fg data-[state=active]:border-accent-indicator data-[state=active]:text-fg"
    >
      {children}
      {count !== undefined && <span className="rounded-full bg-surface-sunken px-1.5 text-xs text-fg-muted tabular">{count}</span>}
    </T.Trigger>
  );
}
